var _path, _path2, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessenger = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 0C3.49337 0 0 3.30113 0 7.76001C0 10.0923 0.955842 12.1077 2.51245 13.4997C2.64312 13.6167 2.722 13.7805 2.72736 13.9559L2.77093 15.3789C2.78485 15.8328 3.25372 16.1282 3.66908 15.9448L5.25697 15.2439C5.39158 15.1845 5.54241 15.1735 5.68425 15.2125C6.41393 15.4131 7.19054 15.52 8.00001 15.52C12.5067 15.52 16 12.2189 16 7.76001C16 3.30113 12.5067 0 8.00001 0Z",
    fill: "url(#paint0_radial_1_3220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1961 10.0294L5.5461 6.30104C5.91991 5.70792 6.72039 5.56024 7.28127 5.98088L9.15035 7.38269C9.32184 7.51133 9.55779 7.51065 9.72856 7.38105L12.2528 5.46528C12.5898 5.2096 13.0296 5.6128 12.8041 5.97061L10.4541 9.69897C10.0802 10.2921 9.27976 10.4398 8.71891 10.0191L6.84979 8.61726C6.67831 8.48865 6.44234 8.48934 6.27159 8.61894L3.7473 10.5347C3.41039 10.7904 2.97058 10.3872 3.1961 10.0294Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_3220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.0796 15.9144) scale(17.4336 17.4335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609754,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934823,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessenger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messenger.62399eb8.svg";
export { ForwardRef as ReactComponent };